import { render, staticRenderFns } from "./index copy.vue?vue&type=template&id=e1da784a&"
import script from "./index copy.vue?vue&type=script&lang=js&"
export * from "./index copy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports